export default "__VITE_ASSET__zpKgI0vi__"